import { WithStyles, withStyles } from '@mui/styles';

import { muiStyles } from './ACGDetailsStyles';
import { ACGDetails } from './ACGNumberDetails';

export interface ACGDetailsProps extends WithStyles<typeof muiStyles> {
    match: any;
    editACG?: (acgObj) => void;
}

export default withStyles(muiStyles)(ACGDetails);